import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-additional-admin-features',
  templateUrl: './additional-admin-features.component.html',
  styleUrls: ['./additional-admin-features.component.scss']
})
export class AdditionalAdminFeaturesComponent implements OnInit {
    @Input() targetTab: string;

    constructor() { }

    ngOnInit() { }

}
